import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { ConfigService } from '../services/config.service';
@Injectable({
  providedIn: 'root'
})
export class BackOfficeService {

    baseUrl!: String;

    ParseHeaders = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    sellerId = 0;

    constructor(public http: HttpClient,
        private commonConfigService: ConfigService) { 
        this.baseUrl = this.commonConfigService.getBaseUrl();

    }

    public getAllCollection() {
        let url = this.baseUrl + '/api/Reports/GetPaymentsOfCustomers';
        let sendingData = {
            "takeAll": true,
            "skip": 0,
            "take": 0,
            "customerId": 0,
            "sellerId": this.sellerId,
            "reportFor": "user"
        };
        return this.http.post(url, sendingData, this.ParseHeaders);
    }

    public getAllCustomerCreditBalance() {
        let url = this.baseUrl + '/api/Reports/GetBalancesFromIntegatedAccounts';
        let sendingData = {
            "takeAll": true,
            "skip": 0,
            "take": 0,
            "customerId": 0,
            "sellerId": this.sellerId
        };
        return this.http.post(url, sendingData, this.ParseHeaders);
    }

    public clearCustomerSelection() {
        const RouteUser = (localStorage.getItem('admin_Details')) ? (JSON.parse(localStorage.getItem('admin_Details'))) : {};
        localStorage.setItem("SelectedUser",JSON.stringify(RouteUser));
    }
}